import { useTranslation } from "react-i18next";
import homeBg from "../assets/images/home.jpeg";

const Legal = () => {
  const { t } = useTranslation("global");

  return (
    <section
      className="relative bg-center bg-cover min-h-screen bg-no-repeat"
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="container mx-auto relative z-10 py-20 px-4">
        <div className="max-w-4xl mx-auto bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg backdrop-filter backdrop-blur-md p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-200 mb-8 text-center">
            {t("Legal.title")}
          </h1>

          <div className="space-y-6 text-gray-300">
            {/* Company Information */}
            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.companyInfo.title")}
              </h2>
              <p className="mb-2">
                <strong className="text-white">
                  {t("Legal.companyInfo.companyName")}
                </strong>{" "}
                {t("Legal.companyInfo.companyValue")}
              </p>
              <p className="mb-2">
                <strong className="text-white">
                  {t("Legal.companyInfo.address")}
                </strong>{" "}
                {t("Legal.companyInfo.addressValue")}
              </p>
              <p className="mb-2">
                <strong className="text-white">
                  {t("Legal.companyInfo.contact")}
                </strong>{" "}
                {t("Legal.companyInfo.contactValue")}
              </p>
            </section>

            {/* Copyright Notice */}
            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.copyright.title")}
              </h2>
              <p>{t("Legal.copyright.text")}</p>
            </section>

            {/* Terms of Use */}
            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.terms.title")}
              </h2>
              <p className="mb-4">{t("Legal.terms.intro")}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t("Legal.terms.item1")}</li>
                <li>{t("Legal.terms.item2")}</li>
                <li>{t("Legal.terms.item3")}</li>
                <li>{t("Legal.terms.item4")}</li>
              </ul>
            </section>

            {/* Privacy Policy */}
            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.privacy.title")}
              </h2>
              <p className="mb-4">{t("Legal.privacy.intro")}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t("Legal.privacy.item1")}</li>
                <li>{t("Legal.privacy.item2")}</li>
                <li>{t("Legal.privacy.item3")}</li>
                <li>{t("Legal.privacy.item4")}</li>
              </ul>
            </section>

            {/* Limitation of Liability */}
            <section>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.liability.title")}
              </h2>
              <p>{t("Legal.liability.text")}</p>
            </section>

            {/* Contact Information */}
            <section className="pt-6 border-t border-gray-600">
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-200 mb-4">
                {t("Legal.contactUs.title")}
              </h2>
              <p>{t("Legal.contactUs.text")}</p>
              <p className="mt-2">
                <strong className="text-white">
                  {t("Legal.contactUs.email")}
                </strong>
                <a
                  href="mailto:legal@flyxom.com"
                  className="text-[#fcab21] hover:text-yellow-600 ml-1"
                >
                  {t("Legal.contactUs.emailValue")}
                </a>
              </p>
            </section>

            <div className="text-sm text-gray-400 text-center pt-6 border-t border-gray-600">
              {t("Legal.lastUpdated")} {new Date().toLocaleDateString()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legal;
